import React, { useState, useEffect } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import StudentDashboardLayout from "./StudentDashboardLayout";
import { fetchAllEventsForStudent } from "../../utils/Api";

const localizer = momentLocalizer(moment);

const StudentAcademicCalender = () => {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await fetchAllEventsForStudent();
        const fetchedEvents = Array.isArray(response)
          ? response
          : response.events;
        setEvents(fetchedEvents);
      } catch (error) {
        console.error("Error fetching events:", error);
      }
    };
    fetchEvents();
  }, []);

  const eventStyleGetter = (event) => {
    let backgroundColor = "#3174ad";
    if (event.type === "Holiday") {
      backgroundColor = "#4299e1";
    } else if (event.type === "Special Occasion") {
      backgroundColor = "#d69e2e";
    }
    return {
      style: {
        backgroundColor,
        borderRadius: "5px",
        opacity: 0.8,
        color: "white",
        border: "0px",
        display: "block",
      },
    };
  };

  return (
    <StudentDashboardLayout>
      <div className="mb-4 text-2xl font-bold">Academic Calender</div>
      <Calendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="start"
        eventPropGetter={eventStyleGetter}
        style={{ height: 500 }}
      />
    </StudentDashboardLayout>
  );
};

export default StudentAcademicCalender;